var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center leading-none rounded-full font-medium text-center uppercase text-2xl text-white fixed-circle",style:(_vm.divStyle)},[_c('span',{staticClass:"mb-2px mx-auto"},[_vm._v(" "+_vm._s(_vm.computedGrade)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }